import React from 'react';
import PropTypes from 'prop-types';

const FileFormat = ({ format, ...rest }) => {
  switch (format) {
    case 'jpeg':
      return (
        <svg
          width="21"
          height="24"
          viewBox="0 0 21 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          <path
            d="M4.5 0C3.675 0 3 0.675 3 1.5V22.5C3 23.325 3.675 24 4.5 24H19.5C20.325 24 21 23.325 21 22.5V6L15 0H4.5Z"
            fill="#DCE0DA"
          />
          <path
            d="M16.5 6H21L15 0V4.5C15 5.325 15.675 6 16.5 6Z"
            fill="#1D211A"
          />
          <path d="M21 10.5L16.5 6H21V10.5Z" fill="#BFC4BA" />
          <path
            d="M18 19.5C18 19.9125 17.6625 20.25 17.25 20.25H0.75C0.3375 20.25 0 19.9125 0 19.5V12C0 11.5875 0.3375 11.25 0.75 11.25H17.25C17.6625 11.25 18 11.5875 18 12V19.5Z"
            fill="#11817D"
          />
          <path
            d="M17.25 20.25H3V21H17.25C17.6625 21 18 20.6625 18 20.25V19.5C18 19.9125 17.6625 20.25 17.25 20.25Z"
            fill="#D1D8CD"
          />
          <path
            d="M1.03601 17.682C1.32401 17.964 1.70201 18.072 2.11001 18.072C2.93201 18.072 3.52001 17.634 3.52001 16.686V13.998H2.66801V16.674C2.66801 17.064 2.42201 17.316 2.04401 17.316C1.76801 17.316 1.56401 17.178 1.40801 17.028L1.03601 17.682Z"
            fill="white"
          />
          <path
            d="M5.56598 18V16.566H6.58598C7.44998 16.566 7.92998 15.984 7.92998 15.288C7.92998 14.586 7.45598 13.998 6.58598 13.998H4.71398V18H5.56598ZM7.05998 15.282C7.05998 15.618 6.80798 15.834 6.47198 15.834H5.56598V14.73H6.47198C6.80798 14.73 7.05998 14.952 7.05998 15.282Z"
            fill="white"
          />
          <path
            d="M11.6901 18V17.262H9.71012V16.332H11.6481V15.6H9.71012V14.73H11.6901V13.998H8.85812V18H11.6901Z"
            fill="white"
          />
          <path
            d="M12.5642 16.002C12.5642 17.262 13.5242 18.078 14.6942 18.078C15.4202 18.078 15.9902 17.778 16.3982 17.322V15.792H14.4902V16.524H15.5582V17.01C15.3842 17.166 15.0602 17.316 14.6942 17.316C13.9682 17.316 13.4402 16.758 13.4402 16.002C13.4402 15.246 13.9682 14.688 14.6942 14.688C15.1142 14.688 15.4562 14.91 15.6422 15.192L16.3502 14.808C16.0442 14.334 15.5222 13.932 14.6942 13.932C13.5242 13.932 12.5642 14.736 12.5642 16.002Z"
            fill="white"
          />
        </svg>
      );
    case 'png':
      return (
        <svg
          width="21"
          height="24"
          viewBox="0 0 21 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          <path
            d="M4.5 0C3.675 0 3 0.675 3 1.5V22.5C3 23.325 3.675 24 4.5 24H19.5C20.325 24 21 23.325 21 22.5V6L15 0H4.5Z"
            fill="#DCE0DA"
          />
          <path
            d="M16.5 6H21L15 0V4.5C15 5.325 15.675 6 16.5 6Z"
            fill="#1D211A"
          />
          <path d="M21 10.5L16.5 6H21V10.5Z" fill="#BFC4BA" />
          <path
            d="M18 19.5C18 19.9125 17.6625 20.25 17.25 20.25H0.75C0.3375 20.25 0 19.9125 0 19.5V12C0 11.5875 0.3375 11.25 0.75 11.25H17.25C17.6625 11.25 18 11.5875 18 12V19.5Z"
            fill="#CC2776"
          />
          <path
            d="M17.25 20.25H3V21H17.25C17.6625 21 18 20.6625 18 20.25V19.5C18 19.9125 17.6625 20.25 17.25 20.25Z"
            fill="#D1D8CD"
          />
          <path
            d="M2.45601 18V16.327H3.64601C4.65401 16.327 5.21401 15.648 5.21401 14.836C5.21401 14.017 4.66101 13.331 3.64601 13.331H1.46201V18H2.45601ZM4.19901 14.829C4.19901 15.221 3.90501 15.473 3.51301 15.473H2.45601V14.185H3.51301C3.90501 14.185 4.19901 14.444 4.19901 14.829Z"
            fill="white"
          />
          <path
            d="M10.4092 18V13.331H9.41517V16.355L7.25217 13.331H6.23017V18H7.22417V14.864L9.45017 18H10.4092Z"
            fill="white"
          />
          <path
            d="M11.5058 15.669C11.5058 17.139 12.6258 18.091 13.9908 18.091C14.8378 18.091 15.5028 17.741 15.9788 17.209V15.424H13.7528V16.278H14.9988V16.845C14.7958 17.027 14.4178 17.202 13.9908 17.202C13.1438 17.202 12.5278 16.551 12.5278 15.669C12.5278 14.787 13.1438 14.136 13.9908 14.136C14.4808 14.136 14.8798 14.395 15.0968 14.724L15.9228 14.276C15.5658 13.723 14.9568 13.254 13.9908 13.254C12.6258 13.254 11.5058 14.192 11.5058 15.669Z"
            fill="white"
          />
        </svg>
      );
    case 'pdf':
      return (
        <svg
          width="21"
          height="24"
          viewBox="0 0 21 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          <path
            d="M4.5 0C3.675 0 3 0.675 3 1.5V22.5C3 23.325 3.675 24 4.5 24H19.5C20.325 24 21 23.325 21 22.5V6L15 0H4.5Z"
            fill="#DCE0DA"
          />
          <path
            d="M16.5 6H21L15 0V4.5C15 5.325 15.675 6 16.5 6Z"
            fill="#1D211A"
          />
          <path d="M21 10.5L16.5 6H21V10.5Z" fill="#BFC4BA" />
          <path
            d="M18 19.5C18 19.9125 17.6625 20.25 17.25 20.25H0.75C0.3375 20.25 0 19.9125 0 19.5V12C0 11.5875 0.3375 11.25 0.75 11.25H17.25C17.6625 11.25 18 11.5875 18 12V19.5Z"
            fill="#F9781C"
          />
          <path
            d="M17.25 20.25H3V21H17.25C17.6625 21 18 20.6625 18 20.25V19.5C18 19.9125 17.6625 20.25 17.25 20.25Z"
            fill="#D1D8CD"
          />
          <path
            d="M3.45601 18V16.327H4.64601C5.65401 16.327 6.21401 15.648 6.21401 14.836C6.21401 14.017 5.66101 13.331 4.64601 13.331H2.46201V18H3.45601ZM5.19901 14.829C5.19901 15.221 4.90501 15.473 4.51301 15.473H3.45601V14.185H4.51301C4.90501 14.185 5.19901 14.444 5.19901 14.829Z"
            fill="white"
          />
          <path
            d="M9.07117 18C10.5342 18 11.5492 17.076 11.5492 15.669C11.5492 14.262 10.5342 13.331 9.07117 13.331H7.23017V18H9.07117ZM8.22417 14.206H9.07117C10.0302 14.206 10.5342 14.843 10.5342 15.669C10.5342 16.46 9.99517 17.125 9.07117 17.125H8.22417V14.206Z"
            fill="white"
          />
          <path
            d="M13.6486 18V16.054H15.9096V15.2H13.6486V14.185H15.9586V13.331H12.6546V18H13.6486Z"
            fill="white"
          />
        </svg>
      );
    default:
      return (
        <svg
          width="18"
          height="24"
          viewBox="0 0 18 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          <path
            d="M1.5 0C0.675 0 0 0.675 0 1.5V22.5C0 23.325 0.675 24 1.5 24H16.5C17.325 24 18 23.325 18 22.5V6L12 0H1.5Z"
            fill="#DCE0DA"
          />
          <path
            d="M13.5 6H18L12 0V4.5C12 5.325 12.675 6 13.5 6Z"
            fill="#1D211A"
          />
          <path d="M18 10.5L13.5 6H18V10.5Z" fill="#BFC4BA" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 15.75C16 16.1642 15.6642 16.5 15.25 16.5H2.75C2.33579 16.5 2 16.1642 2 15.75C2 15.3358 2.33579 15 2.75 15H15.25C15.6642 15 16 15.3358 16 15.75Z"
            fill="#A6AAA3"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 12.75C16 13.1642 15.6642 13.5 15.25 13.5H2.75C2.33579 13.5 2 13.1642 2 12.75C2 12.3358 2.33579 12 2.75 12H15.25C15.6642 12 16 12.3358 16 12.75Z"
            fill="#A6AAA3"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 9.69446C16 10.1087 15.6642 10.4445 15.25 10.4445H2.75C2.33579 10.4445 2 10.1087 2 9.69446C2 9.28024 2.33579 8.94446 2.75 8.94446H15.25C15.6642 8.94446 16 9.28024 16 9.69446Z"
            fill="#A6AAA3"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 18.75C9 19.1642 8.66421 19.5 8.25 19.5H2.75C2.33579 19.5 2 19.1642 2 18.75C2 18.3358 2.33579 18 2.75 18H8.25C8.66421 18 9 18.3358 9 18.75Z"
            fill="#A6AAA3"
          />
        </svg>
      );
  }
};

FileFormat.propTypes = {
  format: PropTypes.string,
};

export default FileFormat;
